// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    'journal-entry-batch.page.title': 'Journal Entries',
    'journal-entry-batch.page.search_results': 'Search Results',
    'journal-entry-batch.page.search.title': 'Search Batches',
    'journal-entry-batch.page.view.title': 'View Entry',
    'journal-entry-batch.page.all': 'All',

    'journal-entry-batch.button.find': 'Find Journal Entry Batches',
    'journal-entry-batch.button.search': 'Apply',
    'journal-entry-batch.button.reset': 'Reset',

    'journal-entry-batch.placeholder.search': 'Search journal entry batches',

    'journal-entry-batch.link.create_first_journal_entry_batch': 'Click here to create your first journal entry',
    'journal-entry-batch.link.retry': 'Click here to retry',

    'journal-entry-batch.checkbox.all': 'Check All',
    'journal-entry-batch.checkbox.actions_label': 'with selected',

    'journal-entry-batch.label.account': 'Account',
    'journal-entry-batch.label.debit': 'Debit',
    'journal-entry-batch.label.credit': 'Credit',
    'journal-entry-batch.label.batch_no': 'Batch No',
    'journal-entry-batch.label.is_manual_entry': 'Is Manual Entry',
    'journal-entry-batch.label.journal_entry_date': 'Journal Entry Date',
    'journal-entry-batch.label.memo': 'Memo',

    'journal-entry-batch.sort.field_label': 'Field',
    'journal-entry-batch.sort.direction_label': 'Direction',
    'journal-entry-batch.sort.direction_ascending': 'Ascending',
    'journal-entry-batch.sort.direction_descending': 'Descending',

    'journal-entry-batch.error.message.error_loading_page': 'Sorry, there was an error loading journal entry batch.| Sorry, there was an error loading journal entry batches.',
};
